export default (str = '', values = []) => {
  let result = str;
  Object.entries(values).forEach(([key, value]) => {
    result = result.replace(`%${key}%`, value);
  });
  return result;
};
